const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const am = hours.map((hour) => `${hour} am`);
const pm = hours.map((hour) => `${hour} pm`);
export const HOURS_OPTIONS = am.concat(pm);

export const DRAG_STAGE = 'stage';
export const DRAG_PURSUIT = 'pursuit';

export const GRANTS_GOV_LINK = 'https://www.grants.gov/search-results-detail/';
